import { render } from "./AssetsSheet.vue?vue&type=template&id=9c97a1e2&scoped=true"
import script from "./AssetsSheet.vue?vue&type=script&lang=js"
export * from "./AssetsSheet.vue?vue&type=script&lang=js"

import "./AssetsSheet.vue?vue&type=style&index=0&id=9c97a1e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c97a1e2"]])

export default __exports__